export default __webpack_public_path__ + "static/media/icon-social-white.ef2b5e05.svg";